export const teamIcons = [
  "apple",
  "account_hard_hat",
  "account_tie",
  "baby_carriage",
  "baguette",
  "basket",
  "bread_slice",
  "broom",
  "cart",
  "cash",
  "cash_register",
  "cheese",
  "coffe",
  "cupcake",
  "cookie",
  "carrot",
  "default",
  "dolly",
  "fish",
  "flower",
  "food",
  "fork_knife",
  "forklift",
  "fridge",
  "hamburger",
  "hammer_wrench",
  "meat",
  "milk",
  "pineapple",
  "soda",
  "steak",
  "tshirt",
  "watermelon",
  "sofa",
  "tv",
  "laptop",
  "market",
  "desk_lamp",
  "bed",
] as const;

export type TeamIcon = (typeof teamIcons)[number];

const teamIconTagMapping: Record<TeamIcon, string[]> = {
  apple: ["Frukt", "Grönt"],
  account_hard_hat: ["Bygg", "Jour"],
  account_tie: ["Ledning", "Jour", "Chef", "Driftgrupp"],
  baby_carriage: [],
  baguette: ["Bageri", "Bröd"],
  basket: ["Kolonial", "Golv"],
  bread_slice: ["Bageri"],
  broom: ["Special"],
  cart: ["Kolonial"],
  cash: ["Ekonomi"],
  cash_register: ["Kassa", "Linjen"],
  cheese: ["Ost", "Chark", "Deli"],
  coffe: ["Café", "Förbutik"],
  cupcake: ["Konditori", "Café"],
  cookie: ["Förbutik"],
  carrot: ["Frukt", "Grönt"],
  default: [],
  dolly: ["Lagret"],
  fish: ["Fisk"],
  flower: ["Blommor", "Färsk"],
  food: [],
  fork_knife: ["Restaurangen", "Kök", "Matrum"],
  forklift: ["Lagret", "Logistik"],
  fridge: ["Frys"],
  hamburger: [],
  hammer_wrench: ["Bygg", "Verktyg"],
  meat: ["Kött"],
  milk: ["Mejeri"],
  pineapple: ["Frukt"],
  soda: ["Dryck"],
  steak: ["Kött", "Deli", "Färsk"],
  tshirt: ["Kläder"],
  watermelon: ["Frukt", "Grönt"],
  sofa: ["Vardagsrum"],
  tv: ["Styrtavla", "Vardagsrum"],
  laptop: ["Kontor", "Online"],
  market: ["Förbutik", "Market", "Butik", "Marknad"],
  desk_lamp: ["Lampor"],
  bed: ["Sovrum"],
};

const keys = Object.keys(teamIconTagMapping) as TeamIcon[];

const matchIconTags =
  (teamName: string) => (icon: { type: TeamIcon; tags: string[] }) =>
    icon.tags.filter((tag) =>
      teamName.toLowerCase().includes(tag.toLowerCase())
    ).length > 0;

export function getTeamIconSuggestions(
  teamName: string,
  usedIcons: TeamIcon[]
) {
  const unusedIcons = keys
    .filter((icon) => !usedIcons.includes(icon))
    .map((type) => ({
      type,
      tags: teamIconTagMapping[type],
    }));
  const unusedMatches = unusedIcons.filter(matchIconTags(teamName));
  if (unusedMatches.length > 0) {
    return unusedMatches.map((icon) => icon.type);
  }
  const allIcons = keys.map((type) => ({
    type,
    tags: teamIconTagMapping[type],
  }));
  const allIconsMatches = allIcons.filter(matchIconTags(teamName));

  return [...allIconsMatches.map((icon) => icon.type), "default" as const];
}
